import { Component, inject, Signal, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { ActivatedRoute } from '@angular/router';
import { ConnectionsComponent } from '@app/modules/client-management/containers/connections/connections.component';
import { FeatureFlagPipe } from '@core';
import { ChildClient, UserRolesIds } from '@models';
import { Store } from '@ngrx/store';
import { AuthSelectors, ClientManagementActions, ClientManagementSelectors } from '@ngrx-store';
import { MainInputFormComponent, PageHeaderComponent } from '@ui';

import { PhoneNumberComponent } from '../phone-number/phone-number.component';
import { RequireTotpComponent } from '../require-totp/require-totp.component';
import { SessionTimeoutComponent } from '../session-timeout/session-timeout.component';
import { TwoWayCommunicationComponent } from '../two-way-communication/two-way-communication';

enum SettingsTab {
  BasicInfo = 'basic-info',
  Connections = 'connections',
}

@Component({
  imports: [MatCardModule, FormsModule, PageHeaderComponent, MainInputFormComponent, PhoneNumberComponent, TwoWayCommunicationComponent, SessionTimeoutComponent, RequireTotpComponent, FeatureFlagPipe, ConnectionsComponent],
  selector: 'avs-settings',
  standalone: true,
  templateUrl: './settings.component.html',
})
export class SettingsComponent {
  protected client: Signal<ChildClient | undefined>;
  protected eUserRolesIds = UserRolesIds;
  protected readonly eSettingsTab = SettingsTab;
  protected readonly selectedTab = signal<SettingsTab>(
    inject(ActivatedRoute).snapshot.queryParamMap.get('tab') === SettingsTab.Connections
      ? SettingsTab.Connections
      : SettingsTab.BasicInfo,
  );
  protected userRole: Signal<UserRolesIds>;

  private store = inject(Store);

  constructor() {
    this.client = this.store.selectSignal(ClientManagementSelectors.getCurrentClient);
    this.userRole = this.store.selectSignal(AuthSelectors.userRole);
  }

  protected updateClientData(fieldData: Record<string, string>, client: ChildClient) {
    this.store.dispatch(ClientManagementActions.updateChildClient({ clientClientId: client.id, clientData: fieldData }));
  }

  protected selectTab(tab: SettingsTab) {
    this.selectedTab.set(tab);
  }
}
